import { PropertyTypeEnum } from '~/core/entities/CRMEnums';

/**
 * Agrupamento de property_type usado na recomendação de Shorts (Tabela 3 da
 * PP-2210). `commercial` fica de fora de propósito — nenhum grupo definido.
 */
const PROPERTY_TYPE_GROUP_BY_VALUE: Partial<Record<PropertyTypeEnum, string>> =
	{
		[PropertyTypeEnum.HOUSE]: 'house',
		[PropertyTypeEnum.CONDO_HOUSE]: 'house',
		[PropertyTypeEnum.VILLAGE_HOUSE]: 'house',
		[PropertyTypeEnum.APARTMENT]: 'apartment',
		[PropertyTypeEnum.GARDEN]: 'apartment',
		[PropertyTypeEnum.DUPLEX]: 'apartment',
		[PropertyTypeEnum.TRIPLEX]: 'apartment',
		[PropertyTypeEnum.PENTHOUSE]: 'apartment',
		[PropertyTypeEnum.LOFT]: 'apartment',
		[PropertyTypeEnum.STUDIO]: 'apartment',
		[PropertyTypeEnum.FLAT]: 'apartment',
		[PropertyTypeEnum.LAND]: 'land',
		[PropertyTypeEnum.CONDO_LAND]: 'land'
	};

export function getPropertyTypeGroup(
	propertyType: PropertyTypeEnum
): string | undefined {
	return PROPERTY_TYPE_GROUP_BY_VALUE[propertyType];
}
